import './List-1ec9d6d9.css';

var classes = {"List":"prc-ActionList-List-bKPOb"};

export { classes as default };
